import { render, staticRenderFns } from "./RegularOrdersAssignForm.vue?vue&type=template&id=33db9de5&scoped=true&"
import script from "./RegularOrdersAssignForm.vue?vue&type=script&lang=ts&"
export * from "./RegularOrdersAssignForm.vue?vue&type=script&lang=ts&"
import style0 from "./RegularOrdersAssignForm.vue?vue&type=style&index=0&id=33db9de5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33db9de5",
  null
  
)

export default component.exports